import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchScoredRedFlags, validateScoredRedFlag } from '../api/scoredRedFlags';

export const useScoredRedFlags = (caseNumber) => {
  return useQuery({
    queryKey: ['scored-red-flags', caseNumber],
    queryFn: () => fetchScoredRedFlags(caseNumber),
    enabled: !!caseNumber,
    staleTime: 30_000,
  });
};

export const useValidateScoredRedFlag = (caseNumber) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ flagId, validation_status, validation_notes }) =>
      validateScoredRedFlag(flagId, { validation_status, validation_notes }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['scored-red-flags', caseNumber] });
    },
  });
};
